import ManualAssignmentTable from "./ManualAssignmentTable";

export default ManualAssignmentTable;
